var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forb text-center"},[_c('h1',{staticClass:"pa-10"},[_vm._v("403")]),_c('Lottie',{staticClass:"mt-anim",attrs:{"options":_vm.defaultOptions}}),_c('h1',{staticClass:"pa-10"},[_vm._v("Forbidden")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }